import styled from 'styled-components'

export const ToggleDescription = styled.i`
  margin-top: var(--size-small);
  font-size: var(--font-extra-small);
  opacity: 0.5;
`
